var map = {
	"./404.svg": "led1",
	"./address-line.svg": "9ruD",
	"./address-name.svg": "ycey",
	"./address-phone.svg": "8N3R",
	"./balance.svg": "s0Sl",
	"./benefits.svg": "4imx",
	"./bug.svg": "sR45",
	"./chart.svg": "pP+V",
	"./clipboard.svg": "O8ZW",
	"./component.svg": "3E2Y",
	"./customer.svg": "tTHx",
	"./dashboard.svg": "FFzs",
	"./documentation.svg": "3kXB",
	"./download.svg": "Kizk",
	"./drag.svg": "n2F2",
	"./edit.svg": "2pVq",
	"./education.svg": "T4eh",
	"./email.svg": "K4X2",
	"./enterprise.svg": "nEFr",
	"./example.svg": "g2f4",
	"./excel.svg": "SOyi",
	"./exit-fullscreen.svg": "Rd2C",
	"./export.svg": "/2ox",
	"./eye-open.svg": "FkT3",
	"./eye.svg": "PI28",
	"./facebook.svg": "8jvp",
	"./file.svg": "X0Vh",
	"./form.svg": "3ekN",
	"./fullscreen.svg": "oggR",
	"./guide.svg": "Fcj2",
	"./ic_down.svg": "dICk",
	"./ic_search.svg": "iXjC",
	"./ic_up.svg": "Lv9y",
	"./icon-delete.svg": "iomW",
	"./icon-ic_screenshot.svg": "Q5zi",
	"./icon.svg": "jDEv",
	"./icon_add.svg": "v6kD",
	"./icon_error.svg": "8xXA",
	"./icon_face.svg": "8CDu",
	"./international.svg": "5Wxw",
	"./inventory.svg": "Ulwp",
	"./language.svg": "iTca",
	"./link.svg": "disj",
	"./list.svg": "svQw",
	"./lock.svg": "0rQG",
	"./logo-mini.svg": "S5za",
	"./logo.svg": "cabP",
	"./logo1.svg": "tsT5",
	"./logout.svg": "FsIF",
	"./message.svg": "7JTB",
	"./method.svg": "zY1W",
	"./money.svg": "Z2Ky",
	"./nested.svg": "9A69",
	"./note.svg": "iBrP",
	"./password.svg": "lDKa",
	"./pdf.svg": "8yG0",
	"./people.svg": "/ZhT",
	"./peoples.svg": "iF2U",
	"./qq.svg": "5crd",
	"./record.svg": "Ld7a",
	"./search.svg": "hgxu",
	"./setting.svg": "xF3N",
	"./shopcart.svg": "ZlFE",
	"./shopping.svg": "YxYZ",
	"./size.svg": "pAoV",
	"./skill.svg": "lJsf",
	"./star.svg": "W7Dr",
	"./subtract.svg": "wccq",
	"./tab.svg": "FlYq",
	"./table.svg": "Bi+W",
	"./theme.svg": "49UM",
	"./tree-table.svg": "rdn6",
	"./tree.svg": "bnW4",
	"./triangle.svg": "+yGk",
	"./user.svg": "pJVp",
	"./wechat.svg": "diHY",
	"./zip.svg": "1eyR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BLIB";


//////////////////
// WEBPACK FOOTER
// ./src/admin/icons/svg nonrecursive \.svg$
// module id = BLIB
// module chunks = 8